import React from 'react';
import { UUID } from '../../../../types/shared/UUID';
import { IStandardDocumentVersionData } from '../../../../types/order/documents/shared/interfaces';
import { eDocumentVisibilityType } from '../../../../types/order/documents/eDocumentVisibilityType';
import { clientUrls } from '../../../../ui-toolkit/rest/ClientUrlFactory';
import { ShowPolicyDocumentData } from './showPolicyDocumentData/ShowPolicyDocumentData';
import { FlexRow, NavigationItem } from '../../../../ui-toolkit';
import { PolicyTypeEnum } from '../../../../policyUI/classes/PolicyTypeEnum';
import {
  deleteDocument,
  publishDocument,
  unpublishDocument,
} from '../../../../store/order/documents/adminDocuments/dispatch';
import { useSelector } from 'react-redux';
import { RootStore } from '../../../../store/types';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../store/store';

export interface IGenericEditPolicyProps {
  isAmericanDigital: boolean;
  policy: IStandardDocumentVersionData;
  policyType: PolicyTypeEnum;
  label: string;
}

export const GenericEditPolicy: React.FC<IGenericEditPolicyProps> = ({
  isAmericanDigital,
  policy,
  policyType,
  label,
}) => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const dispatch = useAppDispatch();

  const onDeleteDocument = (documentId: string, versionId: string) =>
    dispatch(deleteDocument(orderId, documentId, versionId));
  const onPublishDocument = (documentId: string, visibilityType: eDocumentVisibilityType) =>
    dispatch(publishDocument(orderId, documentId, visibilityType));
  const onUnpublishDocument = (documentId: string, visibilityType: eDocumentVisibilityType) =>
    dispatch(unpublishDocument(orderId, documentId, visibilityType));

  const { deleteDocumentsFetchStatus, documentsActionFetchStatus } = useSelector(
    ({ order }: RootStore) => order.documents.adminDocuments
  );

  return (
    <>
      <ShowPolicyDocumentData
        document={policy}
        label={label}
        isAmericanDigital={isAmericanDigital}
        deleteFetchStatus={deleteDocumentsFetchStatus}
        actionFetchStatus={documentsActionFetchStatus}
        onDelete={onDeleteDocument}
        onUnpublish={(id) => onUnpublishDocument(id, eDocumentVisibilityType.Client)}
        onPublish={(id) => onPublishDocument(id, eDocumentVisibilityType.Client)}
      />
      <FlexRow>
        <NavigationItem
          text={'Edit'}
          appearance={'default'}
          intent={'primary'}
          to={clientUrls.urlFor.policyGeneration(orderId, policyType, 'edit')}
        />
      </FlexRow>
    </>
  );
};
